/**
 * Base del backend de IA (Fase 4: contenedor Node en el VPS detrás de Caddy).
 * Con VITE_AI_API_URL seteada (ej. https://api.potencial.com.py/finanzas-ai) las
 * llamadas van cross-origin al VPS; vacía, quedan relativas al host (dev local
 * con el server corriendo en el mismo origen o proxy de Vite).
 */
const AI_API_BASE = ((import.meta.env.VITE_AI_API_URL as string | undefined) ?? '').replace(/\/+$/, '');

export const aiApiUrl = (path: string): string => `${AI_API_BASE}${path}`;

export const aiWsUrl = (path: string): string => {
  if (AI_API_BASE) return AI_API_BASE.replace(/^http/, 'ws') + path;
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${path}`;
};
